@if(!checkCurrentIndexIsLast()){
  <div 
    @fadeOut
    id="welcome"
    class="welcome-view"
  >
    <header class="welcome-view-header">
      <img class="welcome-view__logo" src="/assets/fitur-2026/imgs/cicerone-logo.svg">
    </header>
    
    <main class="welcome-view-main">
      <ul class="welcome-view__message-list">
        <li class="welcome-view__message-item">
          <p 
            class="welcome-view__message-text"
            [class.fadein]="fadeState() === 'fadein'"
            [class.fadeout]="fadeState() === 'fadeout'"
          >
            {{ visibleText() }}
          </p>
        </li>
      </ul>
    </main>
  </div>
}
